<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<h2><span class="h2-inner">Dramatis Personae</span></h2>
<h3 class="firstInSection">Mentioned in History</h3>
<p>King Charles II</p>
<p>Prince Rupert of the Rhine, his Commander in Chief</p>
<p>Prince Maurice, his brother</p>
<p>Sir Richard Crane, Rupert’s deputy commander</p>
<p>Sir Francis Ruce, Rupert’s inept Scoutmaster</p>
<p>Lord George Goring, Maverick Royalist commander in the West</p>
<p>Colonel Gorge Porter, his brother-in-law and field commander</p>
<p>Sir Thomas Bridges, Governor of Bath</p>
<p>General Thomas ‘Black Tom’ Fairfax, commander of Parliament’s New Model Army</p>
<p>Lt General Oliver Cromwell, his commander of horse</p>
<p>Major General Philip Skippon, his commander of foot</p>
<p>Hugh Peters, New Model Army chaplain</p>
<p>Colonel Thomas Rainsborough, New Model Army regimental commander</p>
<p>Colonel John Okey, commander of New Model Army Dragoon regiment</p>
<h3>Unmentioned in history</h3>
<p><em>Royalist</em></p>
<p>Captain Hugo Telling, officer in Rupert’s Lifeguard</p>
<p>Bella Telling née Morrison, his common law wife</p>
<p>Sir Gilbert Morrison, her father, Bristol merchant and arms magnate</p>
<p>Colonel Scipio Porthcurn, Royalist commander</p>
<p>Sir George ‘Slow Georgey’ Winter, commander of Northern Horse regiment</p>
<p>Thomas Winter, his son</p>
<p>Cully Oates, self-serving Royalist corporal</p>
<p><em>Parliamentarian</em></p>
<p>William Sparrow, now sergeant, Hardress Waller’s Regiment, New Model Army</p>
<p>Mary Keziah Pitt, his sweetheart</p>
<p>Captain Archibald McNabb, Scots officer of horse – Sparrow’s mentor</p>
<p>Captain Hereward Gillingfeather, Hardress Waller’s Regiment, New Model Army</p>
<p>Elder Sergeant Colston Muffet, Billy Butcher, Nicodemus Burke, the same</p>
<p>Captain John Rondo, Okey’s Dragoons, New Model Army</p>
<p>Francy Snow, corporal, the same</p>
<p>Simon ‘Miller’ Arbright, Commander of Parliamentarian regional militia</p>
<p>Edward Telling, Hugo’s elder brother, chaplain in Montagu’s Regiment, New Model Army</p>
<p>Master Nathaniel Eagleton, Chief clerk to the New Model Army</p>
<p><em>Unaligned</em></p>
<p>Thomas Blunt, Butcher and leader of Clubmen</p>
<p>Godspeace Lamb, school teacher and leader of Clubmen</p>
<p>Matilda Dawkins, Ammunition whore</p>
<p>Lady Caroline Winter, Sir George Winter’s wayward wife</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?e5814452